module.exports = __webpack_public_path__ + "img/2.3c55f542.png";